import React from "react";
import { Sparkles, Heart, Check, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const Estetica = () => {
  const { t } = useLang();
  const s = t.estetica;
  return (
    <section
      id="estetica"
      className="relative py-24 md:py-32 bg-rose-50/30 overflow-hidden"
      data-testid="estetica-section"
    >
      <div className="absolute -top-40 right-0 h-[420px] w-[420px] rounded-full bg-rose-200/40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-14 items-center">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 rounded-full bg-rose-100 border border-rose-200/70 px-3 py-1 text-xs font-semibold tracking-widest uppercase text-rose-700">
            <Sparkles className="h-3.5 w-3.5" /> {s.eyebrow}
          </span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
            {s.title}
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">{s.desc}</p>

          <div className="mt-8 grid sm:grid-cols-2 gap-6">
            <div className="rounded-2xl bg-white border border-rose-100 p-6 shadow-sm">
              <h3 className="font-display font-semibold text-base text-slate-900">
                {s.itemsTitle}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {s.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
                    <span className="mt-0.5 inline-flex h-4 w-4 flex-none items-center justify-center rounded-full bg-rose-500 text-white">
                      <Check className="h-2.5 w-2.5" strokeWidth={3} />
                    </span>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
            <div className="rounded-2xl bg-gradient-to-br from-rose-500 to-rose-600 text-white p-6 shadow-lg shadow-rose-900/15">
              <h3 className="font-display font-semibold text-base flex items-center gap-2">
                <Heart className="h-4 w-4" /> {s.benefitsTitle}
              </h3>
              <ul className="mt-4 space-y-3">
                {s.benefits.map((b, i) => (
                  <li key={i} className="text-sm leading-relaxed text-rose-50/95">
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <a
            href="#booking-estetica"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-rose-600 px-6 py-3.5 text-sm font-semibold text-white hover:bg-rose-700 transition-colors shadow-sm hover:shadow-md"
            data-testid="estetica-cta"
          >
            {s.cta}
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        <div className="order-1 lg:order-2 relative">
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden shadow-2xl shadow-rose-900/15">
            <img
              src="https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=1200&q=80&auto=format&fit=crop"
              alt="Tratamiento facial estético"
              className="absolute inset-0 h-full w-full object-cover"
              onError={(e) => {
                e.currentTarget.src = "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=1200&q=80&auto=format&fit=crop";
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-rose-900/20 via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Estetica;
